import pluralize from "pluralize";
import React from "react";

import PackageFeatures from "./PackageFeatures.jsx";

import { handleClick, venueLink } from "./helpers";

const packageTitle = props => {
  const nights = pluralize("Night", props.nights, true);
  const rounds = props.rounds === -1
    ? "Unlimited Rounds"
    : pluralize("Round", props.rounds, true);
  const { transportation = {} } = props;
  const title = [];

  if (transportation.eurotunnel) {
    title.push("Le Shuttle");
  }

  if (transportation.flights) {
    title.push("Flights");
  }

  title.push(nights, rounds);

  return title.join(", ");
};

const ratingAndReviewLink = props => {
  const roundedRating = props.venueStarRating.toString().replace(/\.0+$/, "");
  const { venueReviewCount } = props;
  let link = `${venueLink(props)}#reviews`;

  if (props.lmd) {
    link = link.replace(/last-minute-deals\//, "");
  }

  return (
    <React.Fragment>
      <i className="fa fa-star" aria-hidden="true"></i>
      Rated {roundedRating} by {pluralize("golfer", venueReviewCount, true)}{" "}
      <span>(
        <a href={link} onClick={handleClick("Reviews Link", link)}>
          Read {pluralize("review", venueReviewCount)}<span className="offscreen"> of {props.venueName}</span>
        </a>)
      </span>
    </React.Fragment>
  );
};

const featuredRatingAndReview = props => (
  <p data-component="rating-and-review-link">
    {ratingAndReviewLink(props)}
  </p>
);

const packageSectionHeader = props => (
  <header>
    <h3>
      <a
        href={venueLink(props)}
        onClick={handleClick("Offer Title", venueLink(props))}
      >
        {props.venueName}
      </a>
      {props.isFeatured && <span data-type="featured">Featured</span>}
    </h3>
  </header>
);

const directions = props => {
  const { distance, drivingTime } = props.navigation || {};
  if (distance && distance > 1) {
    return (
      <span>
        <br />
        ({distance} miles away, {drivingTime} drive)
      </span>
    );
  }

  return null;
};

const PackageSection = props => {
  return (
    <section>
      {packageSectionHeader(props)}
      <p>{props.venueRegionName}{directions(props)}</p>
      {!!props.venueStarRating && featuredRatingAndReview(props)}
      <p>{packageTitle(props)}</p>
      <PackageFeatures {...props} />
    </section>
  );
};

export default PackageSection;



// WEBPACK FOOTER //
// ./components/search/package/PackageSection.jsx